import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import CtaCorrenteForm from '../components/CtaCorrenteForm';
import { getTemPermissao } from "../utils/LoginManager";
import CadastroRegistro from '../tutoriais/CadastroRegistro';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    buscaOrdem: { campo: 'cc_descricao', ordem: 'ASC' },
  };

  componentDidMount() {
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, });
    const { busca, pagina, limite, buscaOrdem } = this.state;
    axios
      .get('/contasCorrente', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          buscaDescricao: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.cc_idf) { //editar      
      request = axios.put(`/contasCorrente/update/${registro.cc_idf}`, registro);
    } else { // cadastrar
      request = axios.post(`/contasCorrente/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Registro gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/contasCorrente/show/${registro.cc_idf}`)
      .then(response => {
        const { data } = response;

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            data,
            visualizar,
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/contasCorrente/delete/${registro.cc_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.cc_idf === registro.cc_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
          })
      }
    })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        data: {
          cc_codigo: 0,
        },
        visualizar: false,
      }
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }





  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('CtasCorrentesPage', 'editar') ? (
          <Tooltip title="Editar">
            <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('CtasCorrentesPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : null}
      </ButtonGroup>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })



  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/contasCorrente/ativa/${registro.cc_idf}/1`)
    } else {
      request = axios.put(`/contasCorrente/ativa/${registro.cc_idf}/0`)
    }

    request.then(response => {
      registro.cc_situacao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };

  renderAtiva = (cc_situacao, registro) => {
    return (
      <Switch
        checkedChildren="Ativo"
        unCheckedChildren="Inativo"
        checked={cc_situacao}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
        disabled={getTemPermissao('CtasCorrentesPage', 'editar') ? false : true}
      />
    );
  };

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = this.state.buscaOrdem.campo && this.state.buscaOrdem.campo === column.dataIndex ? (this.state.buscaOrdem.ordem && this.state.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    this.state['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite } = this.state;

    return (
      <div className="contentRoutesContainer">
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span className="tituloPage">Cadastro de Contas Correntes</span>
            <Tooltip title="Ajuda">
              <Button
                type="primary"
                onClick={() => this.setState({ modalOpen: true })}
                icon="question"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
          </div>
          <div className="divider-page1" />

          <div className="pageFiltro">
            {getTemPermissao('CtasCorrentesPage', 'novo') ? (
              <Button
                type="primary"
                onClick={this.onAdicionarClick}
                className="botao-primary"
              >
                Adicionar
              </Button>
            ) : null}

            <Search
              placeholder="Buscar por Descrição"
              onSearch={this.onBuscar}
              enterButton
              className="pageFiltro-busca"
            />

            <CtaCorrenteForm
              visivel={formVisivel}
              onSalvarClick={this.onSalvarClick}
              onCancelarClick={this.onCancelarClick}
              carregando={salvando}
              registroSelecionado={registroSelecionado}
            />

            <CadastroRegistro
              isOpen={this.state.modalOpen}
              onClose={() => this.setState({ modalOpen: false })}
            />
          </div>

          <br />

          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40', '50'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.cc_idf)}
          >
            <Column
              key="cc_codigo"
              dataIndex="cc_codigo"
              title={this.renderTitulo("Código")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={50}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="cc_descricao"
              dataIndex="cc_descricao"
              title={this.renderTitulo("Descrição")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={300}
              align="left"
              className="listaCadastro"
            />

            <Column
              key="cc_situacao"
              dataIndex="cc_situacao"
              title={this.renderTitulo("Situação")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderAtiva}
              width={60}
              align="center"
              className="listaCadastro"
            />

            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
              render={this.renderAcoes}
              width={70}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CtasCorrentesPage.js